/**
 * Created by Andrey Popov on 10.11.20
 */

const LayersSwitcherView = cc.Node.extend({
    ctor: function (layers) {
        this._super();

        this.layers = [];
        this.labels = {};

        const styles = cleverapps.styles.LayersSwitcherView;

        this.onLayerSwitched = function () {};
        this.onLayerVisibilityChanged = function () {};

        this.setAnchorPoint(0.5, 0.5);

        const title = cleverapps.UI.generateOnlyText("Layers", cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);
        title.setAlignment(styles.title);
        this.addChild(title);

        const slider = this.slider = new Slider();
        slider.setAnchorPoint(0.5, 0.5);
        slider.setAlignment(styles.slider);
        slider.setRotation(-90);

        slider.percentChangeCallback = function (sender) {
            const sliderPercent = sender.getPercent();
            let closestLayer = undefined;

            Object.values(this.layers).forEach((layer) => {
                if (!closestLayer || Math.abs(layer.percent - sliderPercent) < Math.abs(closestLayer.percent - sliderPercent)) {
                    closestLayer = layer;
                }
            });

            if (closestLayer) {
                this.slider.setPercent(closestLayer.percent);
                this.setLayer(closestLayer.id);
            }
        }.bind(this);

        this.addChild(slider);

        const bg = this.bg = new cc.Scale9Sprite(bundles.editor.frames.editor_layers_white);
        bg.setAlignment(styles.bg);
        bg.setAnchorPoint(0.5, 0.5);
        this.addChild(bg, -1);

        cleverapps.pointerManager.create(bg, {
            onClick: function () {},
            interactiveScale: false
        });

        this.rebuild(layers);
    },

    updateSize: function (layersCount) {
        const styles = cleverapps.styles.LayersSwitcherView;

        const rawWidth = (layersCount - 1) * styles.slider.layerStep;
        const sliderWidth = cleverapps.clamp(rawWidth, styles.slider.minWidth, styles.slider.maxWidth);
        this.slider.setContentSize(cc.size(sliderWidth, styles.slider.height));

        this.setContentSize(styles.width, sliderWidth + styles.padding * 2);
        this.bg.setContentSize(this.getContentSize());
    },

    rebuild: function (layers) {
        const styles = cleverapps.styles.LayersSwitcherView.label;

        this.updateSize(layers.length);

        const previousLayerId = this.current;
        this.layers = {};

        layers.forEach((layer, index) => {
            const percent = layers.length > 1 ? (index / (layers.length - 1)) * 100 : 100;

            this.layers[layer.id] = {
                id: layer.id,
                text: layer.text,

                index,
                visible: !layer.hidden,
                percent
            };

            this.current = layer.id;
        });

        if (this.layers[previousLayerId]) {
            this.current = previousLayerId;
        }

        Object.values(this.labels).forEach((label) => {
            label.removeFromParent();
        });
        this.labels = {};

        Object.values(this.layers).forEach((layer) => {
            const y = this.slider.y - this.slider.width / 2 + layer.percent / 100 * this.slider.width;

            const text = cleverapps.UI.generateOnlyText(layer.text, cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);

            const eye = new cc.Sprite(layer.visible ? bundles.editor.frames.editor_layers_eye_open : bundles.editor.frames.editor_layers_eye_crossed);
            cleverapps.UI.onClick(eye, () => this.setLayerVisible(layer.id, !layer.visible), { interactiveScale: false });

            const label = new cleverapps.Layout([text, eye], {
                margin: styles.margin,
                direction: cleverapps.UI.HORIZONTAL
            });
            label.setAnchorPoint(0, 0.5);
            label.setAlignment(styles.x, y);
            this.addChild(label);

            label.text = text;
            label.eye = eye;

            this.labels[layer.id] = label;
        });

        const current = this.layers[this.current];
        this.slider.setPercent(current ? current.percent : 100);
    },

    updateEyeButton: function (layerId) {
        const layer = this.layers[layerId];
        const label = this.labels[layerId];
        if (!layer || !label) {
            return;
        }

        label.eye.setSpriteFrame(layer.visible ? bundles.editor.frames.editor_layers_eye_open : bundles.editor.frames.editor_layers_eye_crossed);
    },

    setLayer: function (layerId) {
        const oldLayer = this.layers[this.current];
        const newLayer = this.layers[layerId];

        if (!newLayer || oldLayer === newLayer) {
            return;
        }

        this.current = layerId;

        this.slider.setPercent(newLayer.percent);

        Object.values(this.layers).forEach((layer) => {
            this.setLayerVisible(layer.id, layer.id <= newLayer.id);
        });

        this.onLayerSwitched(layerId);
    },

    setLayerVisible: function (layerId, visible) {
        visible = Boolean(visible);

        const layer = this.layers[layerId];
        if (!layer || layer.visible === visible) {
            return;
        }

        layer.visible = visible;

        this.updateEyeButton(layer.id);
        this.onLayerVisibilityChanged(layer.id, visible);
    }
});

cleverapps.styles.LayersSwitcherView = {
    width: 60,
    padding: 20,

    title: {
        x: { align: "center" },
        y: { align: "top", dy: 35 }
    },

    label: {
        x: 70,
        margin: 6
    },

    slider: {
        height: 9,
        layerStep: 30,
        minWidth: 120,
        maxWidth: 600,

        x: { align: "center" },
        y: { align: "center" }
    },

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
